import { TreeItemData } from '@aibees/elephant/components/checkbox-tree-view';
import { AutocompleteOption } from '@aibees/elephant/feature/search-filters';
import type { TreeViewBaseItem } from '@mui/x-tree-view';

/** Flatten nested tree options to a single-level list of selectable items (leaves only). Parents with doNotSetValueOnSelection are skipped; their children become the list. */
export function flattenTreeOptionsToLeafItems(
  items: TreeViewBaseItem<TreeItemData>[]
): TreeViewBaseItem<TreeItemData>[] {
  const result: TreeViewBaseItem<TreeItemData>[] = [];
  for (const item of items) {
    const hasChildren =
      item.children && Array.isArray(item.children) && item.children.length > 0;
    if (hasChildren && item.doNotSetValueOnSelection) {
      result.push(
        ...flattenTreeOptionsToLeafItems(
          item.children as TreeViewBaseItem<TreeItemData>[]
        )
      );
    } else if (!hasChildren) {
      result.push({ ...item } as TreeViewBaseItem<TreeItemData>);
    } else {
      result.push(
        ...flattenTreeOptionsToLeafItems(
          item.children as TreeViewBaseItem<TreeItemData>[]
        )
      );
    }
  }
  return result;
}

export function parseCommaSeparatedValues(value: string): string[] {
  return value
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v.length > 0);
}

export function transformAutocompleteOptionsToTreeItems(
  options: AutocompleteOption[],
  labelFormatter?: (...args: any) => string,
  delimeter?: string,
  // selectedSet?: Set<string>,
  // multiple?: boolean,
  metadataMap?: Map<string, number>
): TreeViewBaseItem<TreeItemData>[] {
  return (
    options
      .filter((o) => !o.group)
      // .filter((o) => !!multiple || (!multiple && !selectedSet?.has(o.value)))
      .map((option) => ({
        id: option.value,
        label:
          labelFormatter?.(option.label, option.value, { delimeter }) ??
          option.label ??
          option.value,
        value: option.value,
        metadata: option.metadata,
        metadataCount: metadataMap?.get(option.value.toLowerCase()),
      }))
  );
}
